import { createStandardAction } from "typesafe-actions";
import { Chat } from "../../models/Chat";

export const updateChat = createStandardAction("UPDATE_CHAT")<Chat>();
